// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import '../theme/index.css'
import ElementUI from 'element-ui'
import VueI18n from 'vue-i18n'
import VueCookie from 'vue-cookie'
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios';
import VueLazyLoad from 'vue-lazyload'
Vue.use(VueLazyLoad,{
    error:'./static/img/load.gif',
    loading:'./static/img/load.gif'
})
Vue.filter('handle_str',function(input,type,val){
    if(type==1){
        if(input){
            var num = val?val:20;
            if(input.length>num)return input.substring(0,num) + "...";
            else return input;
        }
        else return input;
    }else if(type==2){
        var date = new Date(input * 1000);
        if(!VueCookie.get('language')||VueCookie.get('language')=='zh'){
            var Y = date.getFullYear() + '-';
            var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
            var D = date.getDate()<10 ? '0'+date.getDate():date.getDate();
            return Y+M+D+ " " + date.toTimeString().substr(0, 8);
        }else{
            return date.toDateString();
        }
    }else if(type==3){
        var date = new Date(input * 1000);
        if(!VueCookie.get('language')||VueCookie.get('language')=='zh'){
            var Y = date.getFullYear() + '-';
            var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
            var D = date.getDate()<10 ? '0'+date.getDate():date.getDate();
            return Y+M+D;
        }else{
            return date.toDateString();
        }
    }else if(type==4){
        if(val)return val;
        else return input;
    }
});
Vue.prototype.$axios = axios;
Vue.use(ElementUI)
Vue.use(VueI18n);
Vue.use(VueCookie);
Vue.config.productionTip = false
const i18n = new VueI18n({

    locale: VueCookie.get('language')?VueCookie.get('language'):'zh', // 语言标识
    messages: {
        'zh': require('../lang/zh'),
        'en': require('../lang/en')
    }
})
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  i18n,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js